import { UserID } from '@playq/octopus-common';
import { GenericFailure, CommonSuccess } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';

const disableMfaKey = ['services2', 'admin', 'users', 'disableMfa'];

export const useDisableMFA = (
  options?: UseMutationOptionsExtended<CommonSuccess | undefined, GenericFailure | Error, UserID>
) =>
  useEitherMutation((id: UserID) => services2.adminUsersService.disableMfa(id), {
    mutationKey: disableMfaKey,
    onError: (err) => {
      snackbarService.error('Could not disable MFA. Message: ', err.message);
    },
    ...options,
  });
